import metadata from "@claroty/utilities/infra/metadata";
import { Trans } from "@lingui/react/macro";
import Dialog from "../../../common/Dialog/Dialog";
import NoticeAlert from "../../../common/Icons/NoticeAlert";
import "./NewAppVersionDialog.scss";

const productName = metadata.productName;

const NewAppVersionDialog = () => {
    return (
        <Dialog
            headerIcon={<NoticeAlert className="notice-alert" />}
            headerText="New App Version"
            bottomButtons={
                /* TODO Why not use React.Fragment? */
                [
                    <button key={1} onClick={() => location.reload()} className="new-app-dialog-button">
                        Refresh
                    </button>,
                ]
            }
            isOpen
            className="new-app-version-dialog"
            bodyClassName="body"
            headerClassName="header-container"
            contentClassName="content-container">
            <Trans>
                A new version of the {productName} app is available!
                <br />
                Please refresh to continue using the latest features.
            </Trans>
        </Dialog>
    );
};

export default NewAppVersionDialog;
